import { Injectable } from '@angular/core';
import { makeStateKey, TransferState } from '@angular/platform-browser';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Platform } from '@angular/cdk/platform';
import { environment } from '../../../environments/environment';
import { TrackType } from '../models/tracktype.model';
import { APIListResponse } from '../models/apiresponse.model';
import { Observable, BehaviorSubject, of } from 'rxjs';
import { map, tap } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class TrackTypeService {

  constructor(
    private http: HttpClient,
    private _platform: Platform,
    private _transferState: TransferState
  ) {
  }

  getAllTypes(): Observable<TrackType[]> {
    return this.getTypes({});
  }

  private getTypes(params: {[param: string]: string | string[]}): Observable<TrackType[]> {
    let p = new HttpParams({ fromObject: params });
    // Check if types are cached from server
    const TYPES_KEY = makeStateKey<APIListResponse<Object>>('types-' + p.toString());
    if (this._transferState.hasKey(TYPES_KEY)) {
      const types = this._transferState.get<APIListResponse<Object>>(TYPES_KEY, null);
      this._transferState.remove(TYPES_KEY);
      return of(types.results.map((s) => new TrackType(s)));
    }
    let headers = new HttpHeaders();
    return this.http.get<APIListResponse>(
      environment.apiURL + '/api/v1/tracktypes/',
      {
        headers: headers,
        params: p
      }
    ).pipe(
      tap(res => {
        // If we're on the server cache the genres
        if (!this._platform.isBrowser) {
          this._transferState.set(TYPES_KEY, res);
        }
      }),
      map((res) => res.results.map((s) => new TrackType(s)))
    );
  }
}
